import {ToastType} from './toast-type.enum';

export class Toast {

  constructor(public title: string, public message: string, public type: ToastType) {
  }
}
